import React from "react";
import Card from "../../components/Card";
import { ATTRIBUTE_TYPE_LABEL } from "../../constants/Consts";


export default function AttributeCard({ attribute, onEdit, onDelete, onFilter }) {
  return (
    <Card
      title={attribute.nameBr}
      status={{
        label: attribute.enabled ? "Ativo" : "Inativo",
        color: attribute.enabled ? "green-400" : "disabled",
      }}
      onEdit={onEdit}
      onDelete={onDelete}
      onFilter={onFilter}
    >
      <p>{`ID: ${attribute.id}`}</p>
      <p>{`Ordem: ${attribute.order}`}</p>
      <p>{`Bebida: ${attribute.category.drink.nameBr}`}</p>
      <p>{`Categoria: ${attribute.category.nameBr}`}</p>
      <p>{`Tipo: ${ATTRIBUTE_TYPE_LABEL[attribute.type]}`}</p>
    </Card>
  );
}
